import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const loginURL = 'access/signin';

@Injectable()
export class TwoFaInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        map(response => {
          if (response instanceof HttpResponse) {
            const { url, status, body } = response;

            if (!body) {
              return response;
            }

            const { data } = body;

            if (url.includes(loginURL)) {
              if (status === 203) {
                // 2FA needs to be applied
                return response.clone({
                  body: {
                    data: {
                      ...data,
                      apply_2fa: true,
                    },
                  },
                });
              }

              // TODO: only for debugging w/o API changes
              /*return response.clone({
                body: {
                  data: {
                    ...data,
                    apply_2fa: true,
                    /!*otp: {
                      secret: '12345',
                      qr: '',
                    },*!/
                  },
                },
              });*/
            }
          }

          return response;
        }),
      )
  }
}